import { RefObject, createContext } from 'react';

import SidekickModuleSpec from 'src/models/Sidekick/SidekickModuleSpec';
import { NewThreadModalRef } from './components/NewThreadModal';
import { DeleteConfirmationModalRef } from './components/ThreadBuilder/DeleteConfirmationModal';
import { AnonymousModuleModalRef } from './components/AnonymousModule/AnonymousModuleModal';

export interface ISidekickThreadEditorContext {
  allowedToAddModules: string[];
  anonymousModuleModalRef: RefObject<AnonymousModuleModalRef>;
  deleteConfirmationModalRef: RefObject<DeleteConfirmationModalRef>;
  moduleSpecsMap: Record<string, SidekickModuleSpec>;
  newThreadModalRef: RefObject<NewThreadModalRef>;
  readOnly: boolean;
  root: string;
  scrollableRef: RefObject<HTMLDivElement>;
  thankfulUrl: string;
}

export const SidekickThreadEditorContext = createContext<ISidekickThreadEditorContext>({
  allowedToAddModules: [],
  anonymousModuleModalRef: { current: null },
  deleteConfirmationModalRef: { current: null },
  moduleSpecsMap: {},
  newThreadModalRef: { current: null },
  readOnly: false,
  root: '',
  scrollableRef: { current: null },
  thankfulUrl: '',
});
